// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"Home_overlayWrapper__+mpEr","viewBox":"Home_viewBox__4AHzV"};